import React, { useEffect, useState } from 'react';
import { X, AlertCircle, CheckCircle, AlertTriangle, Info } from 'lucide-react';
import { notificationService, Notification } from '../utils/notificationService';

const NotificationBanner: React.FC = () => {
  const [notification, setNotification] = useState<Notification | null>(null);

  useEffect(() => {
    return notificationService.subscribe((n) => {
      setNotification(n);
    });
  }, []);

  if (!notification) return null;

  const getIcon = () => {
    switch (notification.type) {
      case 'success':
        return <CheckCircle className="text-green-500" size={20} />;
      case 'error':
        return <AlertCircle className="text-red-500" size={20} />;
      case 'warning':
        return <AlertTriangle className="text-amber-500" size={20} />;
      default:
        return <Info className="text-blue-500" size={20} />;
    }
  };

  const getBgColor = () => {
    switch (notification.type) {
      case 'success':
        return 'bg-green-50 border-green-200 text-green-800';
      case 'error':
        return 'bg-red-50 border-red-200 text-red-800';
      case 'warning':
        return 'bg-amber-50 border-amber-200 text-amber-800';
      default:
        return 'bg-blue-50 border-blue-200 text-blue-800';
    }
  };

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] w-full max-w-md px-4 animate-in fade-in slide-in-from-top-4 duration-300">
      <div className={`flex items-start gap-3 p-4 rounded-xl border shadow-lg ${getBgColor()}`}>
        <div className="mt-0.5">{getIcon()}</div>
        <div className="flex-1 text-sm font-medium">
          {notification.message}
        </div>
        <button
          onClick={() => notificationService.hide()}
          className="p-1 rounded-lg hover:bg-black/5 transition-colors"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default NotificationBanner;
